module.exports = __webpack_public_path__ + "img/emoticon-nps-9-off.310db50b.svg";